export default __webpack_public_path__ + "static/media/office3.542c3979.png";